import { type PropsWithChildren, Suspense } from 'react'

export const AdminLoading = () => {
  return (
    <div className="flex items-center justify-center p-4">
      <span className="loading loading-spinner loading-md" />
      <span className="pl-4">Loading</span>
    </div>
  )
}

export const AdminSuspense = ({ children }: PropsWithChildren) => (
  <Suspense fallback={<AdminLoading />}>{children}</Suspense>
)

type QuerySuspenseProps = PropsWithChildren<{
  query: {
    isLoading?: boolean
  }
}>

export const QuerySuspense = ({ query, children }: QuerySuspenseProps) =>
  query.isLoading ? <AdminLoading /> : children
